module.exports = __webpack_public_path__ + "img/SolusiUang.c1b3c11d.png";